import { instance } from '../config/api';

const fetchDashboardFeatures = async ({ keys, limit, offset } = {}) => {
  const params = new URLSearchParams();
  if (Array.isArray(keys)) keys.forEach((k) => params.append('keys', k));
  if (limit !== undefined) params.set('limit', String(limit));
  if (offset !== undefined) params.set('offset', String(offset));
  const query = params.toString();
  const { data } = await instance.get(`/dashboard/features${query ? `?${query}` : ''}`);
  return data;
};

const fetchFeatureFlags = async ({ search, limit = 50, offset = 0, environment = 'live' } = {}) => {
  const params = new URLSearchParams({ limit, offset, environment });
  if (search) params.set('search', search);
  const { data } = await instance.get(`/feature-flags?${params}`);
  return data;
};

const updateFlagGlobalState = async ({ key, state, reason, environment = 'live' }) => {
  const { data } = await instance.patch(`/feature-flags/${key}/global-state`, {
    state,
    reason,
    environment
  });
  return data;
};

const setMerchantOverride = async ({ key, merchantId, state, reason, environment = 'live' }) => {
  const { data } = await instance.put(`/feature-flags/${key}/merchants/${merchantId}/override`, {
    state,
    reason,
    environment
  });
  return data;
};

const removeMerchantOverride = async ({ key, merchantId, reason, environment = 'live' }) => {
  const { data } = await instance.delete(
    `/feature-flags/${key}/merchants/${merchantId}/override`,
    { data: { reason, environment } }
  );
  return data;
};

const evaluateMerchantFlag = async ({ key, merchantId, environment = 'live' }) => {
  const params = new URLSearchParams({ environment });
  const { data } = await instance.get(
    `/feature-flags/${key}/merchants/${merchantId}/evaluation?${params}`
  );
  return data;
};

const fetchFeatureFlagOverrides = async ({
  merchantId,
  search,
  keys,
  limit = 50,
  offset = 0,
  environment = 'live'
} = {}) => {
  const params = new URLSearchParams({ limit, offset, environment });
  if (merchantId) params.set('merchantId', merchantId);
  if (search) params.set('search', search);
  if (keys) params.set('keys', keys);
  const { data } = await instance.get(`/dashboard/features/overrides?${params}`);
  return data;
};

export {
  evaluateMerchantFlag,
  fetchDashboardFeatures,
  fetchFeatureFlagOverrides,
  fetchFeatureFlags,
  removeMerchantOverride,
  setMerchantOverride,
  updateFlagGlobalState
};
